<template>
  <Header />
  <!-- <CustomerWidget /> -->
  <SearchBar type="ALL" />
  <!-- <SearchBar type="RENT" />
  <SearchBar type="SHARE" />
  <SearchBar type="ABO" />
  <SearchBar type="SPECIAL" /> -->
  <CarCategorySlider
    v-if="env.VUE_APP_CARCATEGORYSLIDER === 'true'"
    teleport="crentCarCategorySlider"
    :show-category="true"
  />
  <AboV2VehicleGroups
    v-if="env.VUE_APP_ABOV1 === undefined || !env.VUE_APP_ABOV1 === 'true'"
    teleport="crentAboVehicleGroups"
  />
  <AboV2TopVehicles
    v-if="env.VUE_APP_ABOV1 === undefined || !env.VUE_APP_ABOV1 === 'true'"
    teleport="crentAboTopVehicles"
  />
  <AboV2SuperTopVehicle
    v-if="env.VUE_APP_ABOV1 === undefined || !env.VUE_APP_ABOV1 === 'true'"
    teleport="crentAboSuperTopVehicle"
  />
  <LocationMap />

  <OffersSlider :type="1" v-if="hasOffers" />

  <CarFilter v-if="env.VUE_APP_CARFILTER === 'true'" />
  <FullMap />
  <VehiclesList />
  <VehiclesDetail />
  <!-- <OffersSlider :type="2" /> -->

  <Footer />
</template>

<script>
import { defineComponent } from "vue";

import OffersSlider from "@/components/widgets/OffersSlider.vue"; // @ is an alias to /src
import CarCategorySlider from "@/components/widgets/CarCategorySlider.vue"; // @ is an alias to /src
import LocationMap from "@/components/widgets/LocationMap.vue"; // @ is an alias to /src
import SearchBar from "@/components/widgets/SearchBar.vue"; // @ is an alias to /src
import CarFilter from "@/components/widgets/CarFilter.vue"; // @ is an alias to /src
import VehiclesList from "@/components/widgets/VehiclesList.vue"; /* webpackChunkName: 'VehiclesList.chunk' */
import VehiclesDetail from "@/components/widgets/VehiclesDetail.vue"; /* webpackChunkName: 'VehiclesList.chunk' */
// import CustomerWidget from "@/components/widgets/CustomerWidget.vue"; // @ is an alias to /src

import FullMap from "@/components/widgets/FullMap.vue"; // @ is an alias to /src

import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import Header from "@/components/widgets/Header.vue"; // @ is an alias to /src

import store from "@/store";
import AboV2VehicleGroups from "@/components/widgets/AboV2VehicleGroups.vue";
import AboV2TopVehicles from "@/components/widgets/AboV2TopVehicles.vue";
import AboV2SuperTopVehicle from "@/components/widgets/AboV2SuperTopVehicle.vue";

//import store from "../store";

export default defineComponent({
  name: "Home",
  components: {
    AboV2SuperTopVehicle,
    AboV2VehicleGroups,
    AboV2TopVehicles,
    OffersSlider,
    CarCategorySlider,
    CarFilter,
    LocationMap,
    FullMap,
    SearchBar,
    Footer,
    Header,
    VehiclesList,
    VehiclesDetail,
  },
  data() {
    return {
      env: process.env,
      WinSize: 0,
      hasOffers: false,
    };
  },
  mounted() {
    store.dispatch("userSession/SET_CARCATEGORY", {});
    store.dispatch("userSession/SET_EQUIPMENT", {});
    store.dispatch("userSession/SET_CARTYPE", "");
    store.dispatch("userSession/RESET_VEHICLE");
    store.dispatch("reservation/DELETE_TARIF");
    store.dispatch("payment/DELETE_CONCARDIS");
    store.dispatch("reservation/DELETE_SUCCESS_RESERVATION");
    store.dispatch("offers/DELETE_OFFER");
    this.hasOffers =
      store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE") == "J" &&
      process.env.VUE_APP_OFFERS == "true"
        ? true
        : false;

    // console.log(this.hasOffers);
    // console.log(store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE"));
    // console.log(process.env.VUE_APP_OFFERS);
  },
});
</script>
